module.exports = __webpack_public_path__ + "static/arquibaLogo-9cb41e6a24536f9c4de78b2d4f3bddad.svg";